import {
  ExpandablePanel,
  ExpandablePanelBody,
  ExpandablePanelHeader,
  Typography,
} from "@king-ict/eupisi-ui/components";

import { FormCard } from "./FormCard";

export interface RequestExpandablePanelProps {
  children?: any;
  panelTitle?: string;
  headerColor?: "bg-light" | "bg-white";
}

export const RequestExpandablePanel = ({
  children,
  panelTitle,
  headerColor = "bg-light",
}: RequestExpandablePanelProps) => {
  return (
    <div className="border m-1">
      <ExpandablePanel clickableHeader={true} className="">
        <ExpandablePanelHeader className={`${headerColor} p-1`} small>
          <Typography
            component="span"
            variant="smallBold"
            className="ml-4 mt-3"
          >
            {panelTitle}
          </Typography>
        </ExpandablePanelHeader>
        <ExpandablePanelBody>{children}</ExpandablePanelBody>
      </ExpandablePanel>
    </div>
  );
};
